module.exports = __webpack_public_path__ + "img/Profil_CS-Profii_Standard_CS-115.25d3c1b5.jpg";